import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { fetchDefault } from './Utils.js';
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
    textField: {
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(1),
        width: 200,
    },
    menu: {
        width: 180,
    },
}));



export default function RoomManager(props) {
    const classes = useStyles();
    let history = useHistory();

    var voices = [];

    const setVoiceList = () => {
        voices = window.speechSynthesis.getVoices();
    }

    const speech = (txt) => {
        if (!window.speechSynthesis) {
            alert("음성 재생을 지원하지 않는 브라우저입니다. 크롬, 파이어폭스 등의 최신 브라우저를 이용하세요");
            return;
        }
        var lang = 'ko-KR';
        var utterThis = new SpeechSynthesisUtterance(txt);
        //utterThis.onend = function (event) {
        //    console.log('end');
        //};
        //utterThis.onerror = function (event) {
        //    console.log('error', event);
        //};
        var voiceFound = false;
        for (var i = 0; i < voices.length; i++) {
            if (voices[i].lang.indexOf(lang) >= 0 || voices[i].lang.indexOf(lang.replace('-', '_')) >= 0) {
                utterThis.voice = voices[i];
                voiceFound = true;
            }
        }
        if (!voiceFound) {
            alert('voice not found');
            return;
        }
        utterThis.lang = lang;
        utterThis.pitch = 1;
        utterThis.rate = 0.9; //속도
        window.speechSynthesis.speak(utterThis);
    }



    useEffect(() => {

        setVoiceList();
        if (window.speechSynthesis.onvoiceschanged !== undefined) {
            window.speechSynthesis.onvoiceschanged = setVoiceList;
        }


        const checkMessage = setInterval(() => {

            fetchDefault('/User/CheckRoomMessage?uuid=' + props.match.params.uuid,
                (data) => {

                    if (data.message != null) {
                        speech(data.message);
                    }
                }
            );

        }, 5000);


        return () => {
            clearInterval(checkMessage);
        }
    }, []);

    return (
        <div>
        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/RoomManager.js